import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-50 px-4 text-center">
      <h1 className="text-4xl font-bold text-slate-800">404</h1>
      <p className="text-slate-500">Diese Seite wurde nicht gefunden.</p>
      <Link
        to="/"
        className="inline-flex min-h-touch items-center rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800 focus-visible:outline focus-visible:ring-2 focus-visible:ring-slate-500"
      >
        Zum Dashboard
      </Link>
    </div>
  );
}
